import { createContext, useCallback, useContext, useState } from "react";

const SupportContext = createContext(null);

export function SupportProvider({ children }) {
  // prefill: { module?, subject?, message?, target_id?, target_url?, error_message?, error_code? }
  const [state, setState] = useState({ open: false, prefill: {} });

  const openSupport = useCallback((prefill = {}) => {
    setState({ open: true, prefill });
  }, []);

  const closeSupport = useCallback(() => {
    setState({ open: false, prefill: {} });
  }, []);

  return (
    <SupportContext.Provider value={{ ...state, openSupport, closeSupport }}>
      {children}
    </SupportContext.Provider>
  );
}

export const useSupport = () => {
  const ctx = useContext(SupportContext);
  if (!ctx) throw new Error("useSupport must be used within SupportProvider");
  return ctx;
};
